export { DocumentacionList, GuiaList, guiaColumnasFijas, GuiaListMem, DocumentacionesIndex, GuiasIndex } from "./listados";
export { CotizacionView } from "./documentacion";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/index.tsx